<template>
  <v-container>
    <v-spacer/>
    <v-row>
      <v-col cols="8" offset="2">
        <v-form ref="form" class="mt-5  py-3" @submit.prevent="doLogin">
          <v-text-field
              v-model="email"
              :rules="[rules.required, rules.email]"
              hide-details="auto"
              label="Email"
          ></v-text-field>
          <v-spacer/>
          <v-text-field
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-btn block class="mb-4 mt-2" type="submit">
            Login
          </v-btn>
          <div id="password-reset-link">
            <router-link to="password-reset">Forgot your password?</router-link>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import rules from '../helpers/forms'
import {mapActions, mapMutations} from 'vuex'


export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      rules: rules
    }
  },
  methods: {
    ...mapActions([
      'getCategoriesList',
      'getTagsList',
      'getPhotosList',
      'getUsersList',
      'getJobList',
      'getProjectList',
      'getRolesList',
      'getQCList',
      'getSAList'
    ]),
    ...mapMutations(['logout']),
    doLogout() {
      this.logout()
      this.$router.push('/login')

    },
    doLogin() {
      var valid = this.$refs.form.validate()
      if (valid) {
        this.$store.dispatch('postLogin', {email: this.email, password: this.password})
            .then(() => {
              this.getCategoriesList()
              this.getTagsList()
              this.getPhotosList()
              this.getUsersList()
              this.getJobList()
              this.getProjectList()
              this.getRolesList()

              if (this.$store.state.auth.profile.user.roles.length === 1 && this.$store.state.auth.profile.user.roles.includes('Tagger')) {
                this.$router.push('/tagging')
              }

              if (this.$store.state.auth.profile.user.roles.length === 1 && this.$store.state.auth.profile.user.roles.includes('Quality Control')) {
                this.$router.push('/quality-control')

              }

              if (this.$store.state.auth.profile.user.roles.length === 1 && this.$store.state.auth.profile.user.roles.includes('Sys Admin')) {
                this.$router.push('/manage-tags')

              }

              if (this.$store.state.auth.profile.user.roles.length === 1 && this.$store.state.auth.profile.user.roles.includes('Auth Admin')) {
                this.$router.push('/manage-users')
              }

              if (this.$store.state.auth.profile.user.roles.length !== 1) {
                this.$router.push('/tagging')

              }

            })
      }

    }
  }
}
</script>

<style>
#password-reset-link {
  text-align: center;
  width: 100%;
  margin-top: 4px;

}
</style>
